import script from "./SaveButton.vue?vue&type=script&setup=true&lang=js"
export * from "./SaveButton.vue?vue&type=script&setup=true&lang=js"

import "./SaveButton.vue?vue&type=style&index=0&id=6c88b79c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c88b79c"]])

export default __exports__